
export default {
    vi: {
        header: 'Đăng nhập',
        description: 'Đăng nhập bằng tài khoản của bạn',
        username: 'Nhập tên tài khoản',
        captcha: 'Nhập captcha',
        password: 'Nhập mật khẩu',
        forgotpassword: 'Quên mật khẩu?',
        register: 'Đăng ký',
        login: 'Đăng nhập',
        others: 'Hoặc đăng nhập với',
        invalidUsername: 'Tên tài khoản không hợp lệ',
        invalidPassword: 'Mật khẩu không hợp lệ',
        invalidCaptcha: 'Captcha trống',
    }, 
    en: {
        header: 'Login',
        description: 'Login with your account',
        username: 'Enter your username',
        captcha: 'Enter captcha',
        password: 'Enter password',
        forgotpassword: 'Forgot password?',
        register: 'Register',
        login: 'Login',
        others: 'Login with other options',
        invalidUsername: 'Username is invalid',
        invalidPassword: 'Password is invalid',
        invalidCaptcha: 'Captcha is invalid',
    }
}
